"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTrust = void 0;
var React = __importStar(require("react"));
var IconTrust = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M12.0015,15.9004 C13.3325,14.9624 16.0005,12.7314 16.0005,11.0434 C16.0005,9.9334 15.3045,9.3094 14.6545,9.0934 C14.0045,8.8794 13.0705,8.9634 12.3995,9.8514 C12.2115,10.1014 11.7885,10.1014 11.6005,9.8514 C11.1235,9.2194 10.5125,8.9954 9.9655,8.9954 C9.7445,8.9954 9.5335,9.0324 9.3455,9.0934 C8.6955,9.3094 8.0005,9.9334 8.0005,11.0434 C8.0005,12.7334 10.6695,14.9634 12.0015,15.9004 Z M14.9705,8.1514 C16.2035,8.5594 17.0005,9.6944 17.0005,11.0434 C17.0005,13.7134 12.7625,16.5964 12.2795,16.9174 C12.1955,16.9714 12.0985,17.0004 12.0015,17.0004 C11.9055,17.0004 11.8085,16.9714 11.7245,16.9174 C11.2415,16.5964 7.0005,13.7144 7.0005,11.0434 C7.0005,9.6944 7.7965,8.5594 9.0295,8.1514 C10.0785,7.8044 11.1895,8.0654 12.0005,8.8134 C12.8105,8.0654 13.9215,7.8044 14.9705,8.1514 Z M12,21 C16.962,21 21,16.963 21,12 C21,7.037 16.962,3 12,3 C7.038,3 3,7.037 3,12 C3,16.963 7.038,21 12,21 Z M12,2 C17.514,2 22,6.486 22,12 C22,17.514 17.514,22 12,22 C6.486,22 2,17.514 2,12 C2,6.486 6.486,2 12,2 Z" }))); };
exports.IconTrust = IconTrust;
exports.IconTrust.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconTrust;
